import { IActionTypes } from '../types';
import { ACTION_TYPES } from '../consts';
import { ICategory, ITransaction } from '../../../types';

export const getBusinessPercentByActionType = (actionType: IActionTypes) => {
  if (actionType === ACTION_TYPES.PERSONAL) return 0;
  if (actionType === ACTION_TYPES.BUSINESS || actionType === ACTION_TYPES.APPROVE) return 1;
  return null;
};

export const getCategoryForTransaction = (transaction: ITransaction, categoriesList: ICategory[], chosenCategoryId?: string) => {
  if (!transaction) return {};
  const categoryExternalId = chosenCategoryId || transaction?.categoryDetails?.categoryExternalId || transaction?.suggestedTaxCategoryId;
  const category = categoriesList.find((categoryItem: ICategory) => categoryItem.id === categoryExternalId);
  return {
    categoryTitle: category?.title || '',
    categoryId: category?.id || '',
    categoryImageName: category?.imageName || '',
    isExpenseType: transaction?.categorizationType === 'EXPENSE',
    isIncomeType: transaction?.categorizationType === 'INCOME',
  };
};

export const isCategoryChosen = (transaction: ITransaction, chosenCategoryId?: string) => !!(chosenCategoryId || transaction?.categoryDetails?.categoryExternalId || transaction?.suggestedTaxCategoryId);

export const getNumOfTransactionsLeftToCategorize = (totalNum: number, categorizedCounter: number) => {
  if (totalNum - categorizedCounter >= 0) return totalNum - categorizedCounter;
  return 0;
};
